export const SITE_NAME = 'AST Construction';
export const SITE_URL = (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(/\/$/, '') || 'https://astweb.ultrakerb.cloud';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/worker.avif`;

export const LOCATION_KEYWORDS = [
  'construction company in Jaffna',
  'residential construction Jaffna',
  'commercial construction Jaffna',
  'industrial construction Jaffna',
  'AST Construction Jaffna',
];

export function absoluteUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
}

export function projectImageAlt(projectTitle: string, location?: string, suffix?: string): string {
  const place = location ? ` in ${location}` : ' in Jaffna';
  const extra = suffix ? ` - ${suffix}` : '';
  return `${projectTitle}${place}${extra} | AST Construction project image`;
}
